import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.848 1c3.203 0 4.805 0 6.029.623a5.72 5.72 0 0 1 2.5 2.5C23 5.347 23 6.949 23 10.153v3.695c0 3.203 0 4.805-.623 6.029a5.72 5.72 0 0 1-2.5 2.5c-1.224.623-2.826.623-6.03.623h-3.695c-3.203 0-4.805 0-6.029-.623a5.72 5.72 0 0 1-2.5-2.5C1 18.653 1 17.051 1 13.847v-3.695c0-3.203 0-4.805.623-6.029a5.72 5.72 0 0 1 2.5-2.5C5.347 1 6.949 1 10.153 1z"
            fill="#E80200"
        />
        <path
            d="M18.319 10.648c0-.546-.12-1.086-.355-1.59a4.2 4.2 0 0 0-1.01-1.346 4.7 4.7 0 0 0-1.513-.9 5.2 5.2 0 0 0-1.785-.316H5.961V17.5h3.146v-2.701h3.771l2.07 2.701h3.37l-2.454-3.194a4.5 4.5 0 0 0 1.793-1.528c.432-.644.66-1.38.662-2.13m-4.662 1.35h-4.55v-2.7h4.55c.834 0 1.516.607 1.516 1.35s-.682 1.35-1.517 1.35"
            fill="white"
        />
    </svg>
));
RabotaByAppBrandSize24Glyph.displayName = 'RabotaByAppBrandSize24Glyph';
